import { useEffect } from 'react';

import { DISPATCH_ACTION, usePayPalScriptReducer } from '@paypal/react-paypal-js';

export function usePaypalSDK(currency: string, flow: paypal.FlowType, clientToken: string): boolean {
	const [{ isPending }, dispatch] = usePayPalScriptReducer();

	useEffect(() => {
		dispatch({
			type: DISPATCH_ACTION.RESET_OPTIONS,
			value: {
				// clientId is required by the type, but it’s not actually used in
				// our setup (PayPal via Braintree). What we really need is dataClientToken.
				// This value is just a dummy to satisfy TypeScript.
				clientId: 'test',
				dataClientToken: clientToken,
				components: 'buttons',
				...(flow === 'vault' && { vault: true, intent: 'tokenize' }),
				...(flow === 'checkout' && { intent: 'authorize' }),
				currency,
			},
		});
	}, [flow, clientToken, dispatch, currency]);

	return isPending;
}
